import {register} from '@shopify/theme-sections';
import Swiper from 'swiper';

const selectors = {
  target: '.logo-list--',
};

register('logo-list', {
  onLoad() {
    this.init();
  },

  init() {
    this.cleanSlide(this.id);
  },

  cleanSlide(id) {
    const target = `${selectors.target}${id}`;
    const targetSelector = document.querySelector(target);

    if (!targetSelector) { return; }

    const desktopItemCount = targetSelector.dataset.desktopItemRow;
    const mobileItemCount = targetSelector.dataset.mobileItemRow;
    const swiper = new Swiper(target, {
      slidesPerView: 4,
      loop: true,
      freeMode: fasle,
      spaceBetween: 16,
      navigation: {
        nextEl: `.swiper-button-next--${id}`,
        prevEl: `.swiper-button-prev--${id}`,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: 'true',
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: mobileItemCount,
        },
        790: {
          slidesPerView: desktopItemCount,
        }
      }
    });
  },

  onBlockSelect: (blockId) => {
    const id = blockId.detail.sectionId;
    const currentSlide = parseInt(blockId.target.dataset.swiperSlideIndex) + 1;
    const target = `${selectors.target}${id}`;
    const swiper = document.querySelector(target).swiper;
    swiper.slideTo(currentSlide, 1000, false);

    console.log(`🤠 Slide to block ${currentSlide}`)
  },

});
